import { apiGet } from '../js/api';
import Server from '../js/config/_server';
import helpers from '../js/helpers';
import { REQUESTS, DeviceClassOptionsMap, ORDER_BY_DIRECTION} from '../js/_constants';
import type { ElasticSearchResponse } from './types/response';

export type SearchParams = Partial<{
    'order[relevance]': ORDER_BY_DIRECTION;
    'order[created]': ORDER_BY_DIRECTION;
    'order[updatedAt]': ORDER_BY_DIRECTION;
    category?: string;
    channelSlug: string;
    createdBy: string;
    createdByCurrentUser: boolean;
    carType?: string;
    deviceNumber?: string;
    serialNumber?: string;
    expiredDate?: string;
    carModel?: string;
    modelYearFrom?: string;
    modelYearTo?: string;
    page?: number;
    query?: string;
    tag?: string;
    kvps?: string;
    title?: string;
    type?: string[];
    deviceClass?: keyof typeof DeviceClassOptionsMap;
    brand?:string[] | string,
    managedMediaOnly?: boolean;
    dealerTitle?: string;
    globalFallback?: boolean;
    fallbackCountries?: string[],
    creatorRole?: string[],
    countries?: string[],
}>;

/**
 * @param {string} query
 * @returns Promise
 */
export const getSearchSuggestions = (query: string) => {
    let url = Server.baseUrl + Server.services.suggest.search;
    url = helpers.addParamsToUrl(url, { query });
    return apiGet(url, { accept: REQUESTS.ACCEPT.JSON });
};

/**
 * @param {object} params
 * @returns Promise
 */
export const getSearch = params => {
    const url = Server.baseUrl + Server.services.search;

    const p = JSON.parse(JSON.stringify(params));

    Object.keys(p).reduce((acc, k) => (!p[k] && delete acc[k],  acc), p);

    return apiGet<ElasticSearchResponse<any>>(url, {
        params: p,
        accept: REQUESTS.ACCEPT.JSON_LD
    });
};
